
export default function Hero() {
  return (
    <>
      {/* FV（メインビジュアル）セクション */}
      <section 
        className="relative py-20 lg:py-32 min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/17a64c4d971417c460d286b46dfcd11d/9eae49be3ee9c5de5f859cda6b081037.jpeg')`
        }}
      >
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg">
              学びを"見える化"する、次世代の研修サポート
            </h1>
            <div className="bg-white/90 backdrop-blur-sm border-2 border-dashed border-gray-300 rounded-lg p-8 mb-12 max-w-3xl mx-auto">
              <p className="text-lg text-gray-600">
                進捗管理から修了証発行まで、LMS機能で研修をスマートに。
充実した10時間超の学習コンテンツで、確かなスキル定着を支援します。
              </p>
            </div>
            
            <div className="max-w-2xl mx-auto">
              <button className="bg-[#00a8ea] text-white px-12 py-4 rounded-lg text-lg font-medium hover:bg-[#0096d6] transition-colors cursor-pointer whitespace-nowrap w-full">
                資料をダウンロード
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 研修講座資料ダウンロードセクション */}
      <section className="py-16 bg-[#266fb7]">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
              研修講座資料ダウンロード
            </h2>
          </div>
          
          <div className="bg-white rounded-lg p-8 mb-16 max-w-6xl mx-auto shadow-sm">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              {/* 左側の画像 */}
              <div className="order-2 lg:order-1">
                <img 
                  src="https://public.readdy.ai/ai/img_res/6e51c6a847bb03bb30bf7179b9bdce31.jpg"
                  alt="研修講座資料"
                  className="w-full h-64 lg:h-80 object-cover object-top rounded-lg shadow-sm"
                />
              </div>
              
              {/* 右側のコンテンツ */}
              <div className="order-1 lg:order-2">
                <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-6 mb-8">
                  <p className="text-base text-gray-700 mb-4">
                    研修講座の詳細資料を無料でダウンロードいただけます
                  </p>
                  <p className="text-sm text-gray-600">
                    カリキュラム詳細・料金・実施スケジュール等が記載されています
                  </p>
                </div>
                
                <div className="flex justify-center">
                  <button className="bg-[#01a7ea] text-white px-8 py-3 rounded border border-[#01a7ea] font-medium hover:bg-[#2d88ba] transition-colors cursor-pointer whitespace-nowrap">
                    資料をダウンロード
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 申込書類一括ダウンロードセクション */}
      <section className="py-16 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              申込書類一括ダウンロード
            </h2>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-8 max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              {/* 左側のコンテンツ */}
              <div>
                <div className="bg-white border-2 border-dashed border-gray-300 rounded-lg p-6 mb-8">
                  <p className="text-base text-gray-700 mb-6">
                    申込に必要な書類を1つのPDFファイルにまとめました
                  </p>
                  
                  <div className="mb-6">
                    <h3 className="text-base font-medium text-gray-700 mb-4">含まれる書類：</h3>
                    <ul className="text-sm text-gray-600 space-y-2">
                      <li>• 申込書</li>
                      <li>• 利用規約</li>
                      <li>• 重要事項説明書</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex justify-center">
                  <div className="bg-[#01a7ea] border-2 border-[#01a7ea] rounded-lg p-6 text-center">
                    <p className="text-base font-medium text-white mb-2">申込書類一括ダウンロード</p>
                    <p className="text-sm text-blue-100">(PDF)</p>
                  </div>
                </div>
              </div>

              {/* 右側の画像 */}
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20application%20documents%20and%20forms%20neatly%20organized%20on%20modern%20office%20desk%2C%20PDF%20files%20and%20paperwork%20with%20clean%20white%20background%2C%20corporate%20application%20materials%20with%20professional%20lighting%2C%20business%20documentation%20in%20organized%20layout%2C%20high-quality%20office%20photography%20with%20soft%20shadows&width=600&height=400&seq=application-docs-002&orientation=landscape"
                  alt="申込書類"
                  className="w-full h-64 lg:h-80 object-cover object-top rounded-lg shadow-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
